import {
  CreativeReportAd,
  CreativeReportData,
  CreativeReportMediaItem,
  CreativeReportRow,
} from "../types";
import CreativeReportCard from "./CreativeReportCard";

type Props = {
  data: CreativeReportData;
  cardsToDisplay?: number;
  setGroupSheetOpen?: (open: boolean) => void;
  setSelectedAdGroup?: (adGroup: CreativeReportRow) => void;
};

const MAX_MEDIA_DISPLAY = 4;

export const getFirstMedia = (ad: CreativeReportAd): CreativeReportMediaItem[] => {
  if (!ad?.creative) return [];

  const media = [
    ...(ad.creative.videos || []).map((video) => ({
      type: "video" as const,
      url: video.permalink_url || video.source,
      ad_name: ad.ad_name,
      thumbnail: ad.creative.thumbnail_url,
    })),
    ...(ad.creative.images || []).map((img) => ({
      type: "image" as const,
      url: img.permalink_url || img.url,
      uncompressed_url: img.uncompressed_url || img.permalink_url,
      ad_name: ad.ad_name,
    })),
  ];

  // If no media but we have ad info, return a default item
  if (media.length === 0 && ad.creative) {
    return [
      {
        type: ad.creative_type,
        url: "",
        ad_name: ad.ad_name,
      },
    ];
  }

  return media.slice(0, 1);
};

const CreativeReportGroupCards = (props: Props) => {
  const { data, cardsToDisplay = 3, setGroupSheetOpen, setSelectedAdGroup } = props;
  const columns = data.data?.columns;
  const rows = data.data?.rows;
  const getMediaItems = (row: CreativeReportRow): CreativeReportMediaItem[] => {
    const items = row.ads.flatMap((ad) => [...getFirstMedia(ad)]);
    if (items.length === 0 && row.creative_thumbnail) {
      return [
        {
          type: row.creative_type,
          url: row.creative_thumbnail,
          thumbnail: row.creative_type === "video" ? row.creative_thumbnail : undefined,
        },
      ];
    }
    return items;
  };
  if (!columns || !rows) return null;
  return (
    <div className="w-full  overflow-hidden">
      <div className="flex-1 flex gap-[35px] overflow-y-auto">
        {rows?.slice(0, cardsToDisplay).map((row, index) => (
          <CreativeReportCard
            key={index}
            columns={columns}
            row={row}
            setGroupSheetOpen={setGroupSheetOpen}
            setSelectedAdGroup={setSelectedAdGroup}
            maxMediaDisplay={MAX_MEDIA_DISPLAY}
            mediaType={row.ads[0]?.creative_type ?? row.creative_type}
            mediaItems={getMediaItems(row)}
          />
        ))}
      </div>
    </div>
  );
};

export default CreativeReportGroupCards;
